/**
 * Controls the main interaction mode on mobile, e.g. "move" to show move arrows.
 * This is an enum to allow for extension like a dedicated "Add" mode.
 */

export function checkIsContentManagerAsset(item) {
  return item.type === 'upload' || item.type === 'web' || item.type === 'zip' || item.type === 'scorm' || item.type === 'event';
}
export function checkIsContentManagerPlaylist(item) {
  return item.type === 'playlist';
}